import { Layout } from "../components/Layout";
import { LoginForm } from "../components/LoginForm";

export const Login = () => {
  return (
    <Layout showHeader={false} pageTitle="Login">
      <LoginForm />
    </Layout>
  );
};
